import { render, staticRenderFns } from "./home-construction.vue?vue&type=template&id=7b7321ac"
import script from "./home-construction.vue?vue&type=script&lang=js"
export * from "./home-construction.vue?vue&type=script&lang=js"
import style0 from "./home-construction.vue?vue&type=style&index=0&id=7b7321ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports